import React from "react";
import { Link } from "react-router-dom";
import image from "../Images/handswithwords.png";
import "../styles/Details.css";

function RsvpImage() {
  return (
    <div className="rsvp-unique-container">
      <img src={image} alt="hands" className="rsvp-unique-image" />
      <Link to="/rsvp" className="rsvp-unique-button">
        RSVP
      </Link>
    </div>
  );
}

export default RsvpImage;
